/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

export function sanitizeFormValues(obj) {
  if (obj === null) return "";
  if (obj === "1") return true;
  if (typeof obj !== "object") return obj;

  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[key] = sanitizeFormValues(value);
    return acc;
  }, {});
}
